module.exports = __webpack_public_path__ + "static/media/sal-kriz.465e23fb.jpg";